class MiniCartSlickUpsell extends MiniCartPlugin {
	constructor(miniCartParent, params) {
		super(miniCartParent);
		this.pluginName = "SlickUpsell";
		this.params = {
			content: params.childrenHTML,
			slick: params.slickParams,
			header: params.header
		};
		this.htmlSelectors = {};
		this.jsSelectors = {};
		this.parent = miniCartParent;
	}
	_updateOn() {
		return;
	}
	ctx(cart, globalCtx) {
		return {}
	}
	_template(ctx) {
		return `
		<div class="hc-mini-cart--upsell-container">
			<div class="hc-mini-cart--upsell-header">
				Select 3 free samples:
			</div>
			<div class="hc-mini-cart--upsell-slider">
				${this.params.content}
			</div>
		</div>
		`;
	}
	onInit() {
		$(this._el.querySelector(".hc-mini-cart--upsell-slider")).slick({
          dots: false, 
          slidesToShow: 4, 
          slidesToScroll: 4,
          prevArrow: '<div class="hc-arrow-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
          nextArrow: '<div class="hc-arrow-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
			...this.params.slickParams
		});
		this._el.addEventListener('click', e => {
			const atc = e.target.closest('[hc-add-to-cart]');
          if (atc) {
            const id = atc.getAttribute("hc-add-to-cart");
            setTimeout(function() {
              document.querySelector('.hc-mini-cart-plugin--SlickUpsell').classList.add('hc_sample');
            }, 150);
            this.parent.addProduct(id, 1);
          }
		})
	}
}